import { useTranslation } from 'react-i18next';
type Props = {
    note?: string | null
};
export default function BikeDetailRemarks({ note }: Props) {
    const { t } = useTranslation();
    const text = note?.trim();
    if (!text) {
        return null;
    }
    return (
        <div className='w-full mb-[min(56px,7.2vw)]'>
            <div className='flex flex-col xsm:flex-row xsm:items-start justify-start xsm:justify-center gap-[min(12px,2vw)]'>
                <p className='text-fs-mid14 font-normal text-[#000] leading-[calc(24/14)] whitespace-pre-wrap break-words xsm:max-w-[min(640px,72vw)]'>
                    {text}
                </p>
            </div>
        </div>
    );
}
